<template>
  <p>You can delete your Allume account if you wish.</p>
  <a-button type="danger" @click="isModalVisible = true">
    Delete Account
  </a-button>
  <a-modal
    title="Delete Account"
    :visible="isModalVisible"
    @ok="handleOk"
    @cancel="isModalVisible = false"
    okText="Confirm"
  >
    <p>
      You will receive a confirmation Email sent to
      <b>{{ currentEmail }}</b> by clicking confirm.
    </p>
  </a-modal>
</template>

<script>
import { AppContext } from '@/models/AppContext';
import { useAuthStore } from '@/shared/stores/authStore';

export default {
  name: 'DeleteAccount',
  computed: {
    currentEmail() {
      return useAuthStore().profileEmail(AppContext.SolCentre);
    },
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    handleOk() {
      this.$http.post(this.$api.confirmDeleteAccount);
      this.isModalVisible = false;
    },
  },
};
</script>

<style scoped></style>
